<template>
  <div>
    <h2>Buscar Indicador por Fecha</h2>
    <form @submit.prevent="buscarIndicador" class="indicador-fecha-form">
      <select v-model="codigoBuscar" class="codigo-dropdown" required>
        <option value="" disabled>Seleccione código</option>
        <option v-for="codigo in codigosDisponibles()" :key="codigo" :value="codigo">{{ codigo }}</option>
      </select>
      <input v-model="fechaBuscar" type="date" required />
      <button class="button-71 small-btn" style="margin-left:1em;">Buscar</button>
    </form>
    <div v-if="resultado && (resultado.valor !== undefined || resultado.valor === null)">
      <div class="indicador-fecha-resultado left-indented">
        <div class="codigo-nombre">{{ codigoBuscar ? codigoBuscar.toUpperCase() : '' }}</div>
        <div class="valor-fecha-row left-indented-row">
          <div class="valor-num" v-if="resultado.valor !== null">{{ formatCurrency(resultado.valor) }}</div>
          <div class="valor-num" v-else>-</div>
          <div class="fecha-label">{{ formatFecha(resultado.fecha) }}</div>
        </div>
      </div>
    </div>
    <div v-else-if="resultado && resultado.valor === undefined">
      <div style="margin-top:1em; color:#c00;">No se encontró el indicador para ese código y fecha.</div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/api/index';
export default {
  name: 'IndicadorFecha',
  inject: ['codigosDisponibles', 'fetchCodigos'],
  data() {
    return {
      codigoBuscar: '',
      fechaBuscar: '',
      resultado: null,
    };
  },
  mounted() {
    this.fetchCodigos();
  },
  methods: {
    async buscarIndicador() {
      this.resultado = null;
      try {
        const res = await apiClient.get(`/indicadores/valor?codigo=${encodeURIComponent(this.codigoBuscar)}&fecha=${this.fechaBuscar}`);
        this.resultado = res.data;
      } catch {
        this.resultado = {};
      }
    },
    formatCurrency(valor) {
      if (valor === null || valor === undefined) return '-';
      return Number(valor).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 2 });
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      return `${d.getDate().toString().padStart(2, '0')}-${meses[d.getMonth()]}-${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.indicador-fecha-form {
  display: flex;
  align-items: center;
  gap: 0.7em;
  margin-bottom: 1.5em;
}
.indicador-fecha-resultado {
  margin-top: 2em;
  text-align: right;
}
.codigo-nombre {
  font-size: 2em;
  font-weight: bold;
  color: #222;
  text-align: left;
  margin-bottom: 0.5em;
}
.valor-fecha-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;
  gap: 2em;
}
.valor-num {
  font-size: 2em;
  font-weight: 700;
  color: #222;
  min-width: 120px;
  text-align: right;
}
.fecha-label {
  font-size: 1.1em;
  color: #444;
  min-width: 120px;
  text-align: right;
}
.left-indented {
  text-align: left;
  margin-left: 2em;
}
.left-indented-row {
  justify-content: flex-start !important;
  gap: 2em;
}
.codigo-dropdown {
  min-width: 140px;
  padding: 0.4em 0.7em;
  border-radius: 6px;
  border: 1px solid #bbb;
  font-size: 1em;
  margin-left: 0.5em;
}
.button-71.small-btn {
  width: auto;
  padding: 0.4em 1.1em;
  font-size: 0.98em;
  border-radius: 8px;
}
</style>
